export default "__VITE_ASSET__DIbmik0V__"